import * as React from 'react';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { IObservableValue, observable } from 'mobx';
import { Paper } from '@material-ui/core';
import { AppBar } from '@material-ui/core';
import { Tabs } from '@material-ui/core';
import { Tab } from '@material-ui/core';
import { translation } from '../../i18n';
import CatalogueTab from './CatalogueTab';
import ModuleTab from './ModuleTab';
import ClusterTab from './ClusterTab';
import QuestionTab from './QuestionTab';

interface Props {
  renderSearch: (showSearch: boolean) => void;
  searchText: IObservableValue<string>;
  resetSearch: () => void;
}

type LocalStyles = 'header' | 'tabContainer';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({

  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  tabContainer: {
    marginTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    width: '80%',
    margin: 'auto'
  }
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class CreateCatalogue extends React.Component<PropsWithStyle, {}> {

  private activeTab: IObservableValue<number> = observable.box(0);

  constructor(props: PropsWithStyle) {
    super(props);
  }

  public render() {
    return (
      <>
        <Paper elevation={1}>
          <AppBar position="static">
            <div className={this.props.classes.header}>
              <div>
                <Tabs value={this.activeTab.get()} onChange={(event, value) => {
                  this.props.resetSearch();
                  this.activeTab.set(value)
                }}>
                  <Tab label={translation.t('catalogue.this')}/>
                  <Tab label={translation.t('module.this')}/>
                  <Tab label={translation.t('cluster.this')}/>
                  <Tab label={translation.t('question.this')}/>
                </Tabs>
              </div>
            </div>
          </AppBar>
          <div className={this.props.classes.tabContainer}>
            {this.activeTab.get() === 0 &&
            <CatalogueTab
              searchText={this.props.searchText} renderSearch={this.props.renderSearch}/>}
            {this.activeTab.get() === 1 &&
            <ModuleTab
              searchText={this.props.searchText} renderSearch={this.props.renderSearch}/>}
            {this.activeTab.get() === 2 &&
            <ClusterTab
              searchText={this.props.searchText} renderSearch={this.props.renderSearch}/>}
            {this.activeTab.get() === 3 &&
            <QuestionTab
              renderSearch={this.props.renderSearch}/>}
          </div>
        </Paper>
      </>
    );
  }
}

export default withStyles(localStyles)(CreateCatalogue);
